import React, { useMemo } from "react";
import { useLocation } from "react-router-dom";
import { feedBackFormProperty } from "../../util/const/property-url-regexst";

const usePropertyHelpTypeLocations = () => {
  const location = useLocation();
  const { isFormEdit, isCreatingDraft, isProject } = feedBackFormProperty(
    location.pathname
  );

  const path = useMemo(() => {
    return {
      isEdit: isFormEdit,
      isCreate: isCreatingDraft,
      isProject: isProject
    };
  }, [isFormEdit, isCreatingDraft, isProject]);
  return path;
};

export default usePropertyHelpTypeLocations;
